import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "account-page" }
const _hoisted_2 = { class: "account-page__top" }
const _hoisted_3 = { class: "account-page__balance" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "account-page__title" }, "Баланс", -1)
const _hoisted_5 = { class: "account-page__value" }
const _hoisted_6 = { class: "account-page__license-number" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "account-page__title" }, "лицевой счёт", -1)
const _hoisted_8 = { class: "account-page__value" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Пополнить баланс")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { title: "Аккаунт" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.account.balance ? _ctx.formatMoney(_ctx.account.balance) : 0) + " тг", 1)
          ]),
          _createElementVNode("a", {
            class: "account-page__transactions-link",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onclickTrans && _ctx.onclickTrans(...args)))
          }, "Транзакции")
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.account.number ? _ctx.account.number : "..."), 1)
        ]),
        _createVNode(_component_base_button, {
          onClick: _ctx.showPaymentModal,
          block: "",
          small: ""
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }))
}